import axiosInstance from "../api/axios";

// Fetch all users
export const fetchAllUsers = async (customerId) => {
  try {
    const response = await axiosInstance.get('/users', {
      params: {customerId: customerId}});
    console.log('Users:', response);
    return response;
  } catch (error) {
    console.error('Error fetching all properties:', error);
    throw error;
  }
};


export const getUserById = async (userId) => {
  try {
    const response = await axiosInstance.get('/users', {
      params: {
        userId: userId,
      },
    });
    return response;
  } catch (error) {
    console.error('Error fetching user by ID:', error);
    throw error;
  }
};

// Create a new user
export const createUser = async (userData) => {
  try {
    const response = await axiosInstance.post('/users', userData);
    console.log('User created:', response);
    return response;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};



export const fetchUserSchedule = async (customerId, loginId,visitFilter, agentId) => {
  try {
    const params = {};
    if (agentId) params.agentId = agentId;
    if (customerId) params.customerId = customerId;
    if (loginId) params.loginId = loginId;
    if (visitFilter) params.visitFilter = visitFilter;

    const response = await axiosInstance.get('/users/property', {params});
    console.log('User property:', response);
    
    // Handle both paginated and non-paginated responses for backward compatibility
    if (response?.items && response.total !== undefined) {
      return response.items;
    } else if (Array.isArray(response)) {
      return response;
    }
    
    return [];
  } catch (error) {
    console.error('Error fetching user property:', error);
    throw error;
  }
};



//schedule a visit
export const scheduleVisit = async (visitData, walkIn = false) => {
  try {
    const response = await axiosInstance.post('/users/property', visitData, {
      params: { walkIn: Boolean(walkIn) },
    });
    console.log('Visit scheduled:', response);
    return response;
  } catch (error) {
    console.error('Error scheduling visit:', error);
    throw error;
  }
};
// Update the existing visit
export const updateVisit = async (updatedVisitData) => {
  try {
   
    const response = await axiosInstance.put("/users/property", updatedVisitData);
    console.log('Visit updated:', response);
    return response;
  } catch (error) {
    console.error('Error updating visit:', error);
    throw error;
  }
};


// Fetch all customers
export const fetchAllCustomers = async (params) => {
  try {
    const response = await axiosInstance.get('/customers',{params: params});
    console.log('Customers:', response);
    return response;
  } catch (error) {
    console.error('Error fetching customers:', error);
    throw error;
  }
};

export const fetchagentlist = async (params) => {
  try {
    const response = await axiosInstance.get('/customers/relation',{params: params});
    console.log('Customers:', response);
    return response;
  } catch (error) {
    console.error('Error fetching customers:', error);
    throw error;
  }
};
export const createCustomersAgentProjectConfig = async (payload) => {
  try {
    // Handle multiple project IDs - if projectIds is an array, send all of them
    const requestPayload = {
      ...payload,
      projectIds: payload.projectIds || (payload.projectId ? [payload.projectId] : [])
    };

    const response = await axiosInstance.post(`/customers/agent/project/configs`, requestPayload);

    console.log('createCustomersAgentProjectConfig', response);
    return response;
  } catch (error) {
    console.error('createCustomersAgentProjectConfig:', error);
    throw error;
  }
};
export const updateAgent = async (agentData, customerId) => {
  try {
      const response = await axiosInstance.put(`/customers?customerId=${customerId}`, agentData, {
         headers: {
          'Content-Type': 'application/json'
          }
       });
      return response;
  } catch (error) {
      console.error("Error updating agent:", error);
      throw error;
  }
};


// Fetch all agent customers
export const fetchAgentCustomers = async () => {
  try {
    const response = await axiosInstance.get('/customers');
    const agentCustomers = response.filter(customer => customer.customerType === 'AGENT');
    console.log('Agent customers:', agentCustomers);
    return agentCustomers;
  } catch (error) {
    console.error('Error fetching agent customers:', error);
    throw error;
  }
};
// Assign agents to property configurations in bulk
export const assignAgentsToConfigs = async (payload) => {
  try {
    const response = await axiosInstance.post('/customers/property/config/bulk-insert', payload);
    console.log('Agents assigned to configs:', response);
    return response;
  } catch (error) {
    console.error('Error assigning agents to configs:', error);
    throw error;
  }
};


export const linkUserToCustomer = async (payload) => {
  try {
    const response = await axiosInstance.post('/customers/user', payload);
    return response;
  } catch (error) {
    console.error('Error linking user to customer:', error);
    throw error;
  }
};


export const updateCustomerSale = async (customerSaleId, payload) => {
  try {
      const response = await axiosInstance.put(`/customer/sales?customerSaleId=${customerSaleId}`, payload);
      return response;
  } catch (error) {
    console.error('Error updating customer sale:', error);
    throw error;
  }
};